import { createContext } from 'react';
import styled from '@emotion/styled';

export const PlainPageHeadingContext = createContext(false);

const PlainPageHeading = styled.h3`
  margin: 0;
  padding: 0 0 ${props => props.contentGap ?? 30}px;
  color: #333;
  font-size: 22px;
  line-height: 28px;
  font-weight: bold;
`;

export default PlainPageHeading;
